<template>
  <div class="app-container">
    <div class="top-content">
      <div class="bg-content">
        <img class="image" :src="headerData.backgroundImageUrl" />
      </div>
      <div class="top-text">
        <div class="title">{{ headerData.title }}</div>
        <div class="subtitle">{{ headerData.subTitle }}</div>
      </div>
    </div>
    <div class="app-main">
      <div
        v-for="(item, index) in listData"
        :key="index"
        :class="index === -1 ? 'main-item-active' : 'main-item'"
        @click="onItemClick(item)"
      >
        <div class="item-left">
          <div class="month">
            {{ getMonth(item.publishTime) }}/{{ getDay(item.publishTime) }}
          </div>
          <div class="year">{{ getYear(item.publishTime) }}</div>
        </div>
        <div class="line"></div>
        <div class="item-right">
          <div class="right-top">
            <div class="right-box">
              <img class="image image-write" src="@/assets/icon_list_write_arrow.png" />
              <img class="image" src="@/assets/icon_list_arrow.png" />
            </div>
            <div class="title">{{ item.title }}</div>
          </div>
          <div class="desc">
            {{ item.thumbnailText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNoticeHeader, getNoticeList } from "@/api/announcementcenter";
import { getMonth, getDay, getYear } from "@/utils/index";
export default {
  name: "AnnouncementCenter",
  data() {
    return {
      headerData: {},
      listData: [],
      getMonth,
      getDay,
      getYear,
    };
  },
  mounted() {
    this._getNoticeHeader();
    this._getNoticeList();
  },
  methods: {
    onItemClick(item) {
      const { id } = item;
      this.$router.push({
        path: "/announcementcenterdetail",
        query: { id },
      });
    },
    //封头配置
    _getNoticeHeader() {
      getNoticeHeader()
        .then((res) => {
          const { data } = res;
          this.headerData = { ...data };
        })
        .catch((res) => {})
        .finally(() => {});
    },
    //列表
    _getNoticeList() {
      getNoticeList()
        .then((res) => {
          const {
            data: { data },
          } = res;
          this.listData = [...data];
        })
        .catch((res) => {})
        .finally(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  margin-top: -120px;
  .top-content {
    position: relative;
    height: 460px;
    .bg-content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      .image {
        width: 100%;
        height: 460px;
      }
    }
    .top-text {
      position: absolute;
      bottom: 100px;
      left: 0;
      right: 0;
      .title {
        color: #ffffff;
        font-size: 72px;
        font-weight: 700;
      }
      .subtitle {
        font-size: 24px;
        color: rgba(255, 255, 255, 0.8);
        font-weight: 400;
      }
    }
  }
  .app-main {
    width: 1320px;
    margin: 90px auto 30px;
    .main-item,
    .main-item-active {
      display: flex;
      cursor: pointer;
      height: 130px;
      align-items: center;
      .item-left {
        width: 216px;
        .month {
          font-size: 50px;
          font-family: MicrosoftYaHei;
          color: #999999;
        }
        .year {
          font-size: 24px;
          font-family: MicrosoftYaHei;
          color: #999999;
        }
      }
      .line {
        width: 1px;
        height: 100px;
        background-color: #cccccc;
      }
      .item-right {
        flex: 1;
        padding-left: 50px;
        padding-right: 50px;
        .right-top {
          display: flex;
          align-items: center;
          .right-box {
            margin-left: -5px;
            .image-write {
              display: none;
            }
            .image {
              margin-top: 8px;
              width: 13px;
              height: 26px;
            }
          }
          .title {
            margin-left: 10px;
            font-size: 24px;
            font-family: MicrosoftYaHei;
            color: #666666;
          }
        }
        .desc {
          width: 987px;
          font-size: 18px;
          overflow: hidden;
          margin-top: 22px;
          text-align: left;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-family: MicrosoftYaHei;
          color: #999999;
        }
      }
    }
    .main-item:hover,
    .main-item-active {
      background-color: #1082ff;
      .item-left {
        .month {
          color: #ffffff;
        }
        .year {
          color: #ffffff;
        }
      }
      .line {
        background-color: rgba($color: #ffffff, $alpha: 0.8);
      }
      .item-right {
        .right-top {
          .right-box{
            .image {
              display: none;
            }
            .image-write {
              display: inline-block;
            }
          }
          .title {
            color: rgba($color: #ffffff, $alpha: 0.8);
          }
        }
        .desc {
          color: rgba($color: #ffffff, $alpha: 0.8);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/announcementcenter/index.vue